import React from 'react'
import { DUE_DETAIL } from '../urls'
import { useDeleteRequest } from '../hooks/request'
import { useModal } from '../hooks/modal'
import DueUpdate from './DueUpdate'
import { getDateTime } from '../utils/date'
import Loader from './common/Loader'

export default function DueItem({ item, brand, index, onUpdate }) {
    const brandRemove = useDeleteRequest({ url: DUE_DETAIL.replace('{id}', item.id) })
    const [showUpdateModal, setShowUpdateModal] = useModal(
        <DueUpdate
            item={item}
            onUpdate={onUpdate}
            onCancel={() => setShowUpdateModal()}
        />,
    )

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await brandRemove.request()
            brand.request()
        }
    }

    return (
        <tr>
            <td>
                {index + 1}
            </td>
            <td>
                {item.name}
            </td>

            <td>
                {getDateTime(item.createdAt)}
            </td>

            <td>
                <div className="is-pulled-right">
                    {!brandRemove.loading ? (
                        <i onClick={onDelete} className="icon pointer ion-md-trash" />
                    ) : <Loader className="icon" />}

                    <i onClick={showUpdateModal} className="icon pointer ion-md-create" />

                </div>
            </td>
        </tr>
    )
}
